<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="value => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <div class="img-logo">
        <img src="../../assets/fabbi_logo.jpeg" class="c-avatar-img" />
      </div>
    </CSidebarBrand>

    <ul class="c-sidebar-nav h-100 ps" style="position: relative;">
      <li class="c-sidebar-nav-item" data-v-3738b722="">
        <router-link
          :to="{ path: `/` }"
          class="c-sidebar-nav-link"
          target="_self"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-speedometer" />
          </svg>
          Dashboard
        </router-link>
      </li>
      <li class="c-sidebar-nav-title">Management</li>
      <li class="c-sidebar-nav-dropdown" @click="dropdown($event)">
        <a class="c-sidebar-nav-dropdown-toggle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-speedometer" />
          </svg>
          {{ $t("sidebar.timesheet.title") }}
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/timesheets` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("sidebar.timesheet.list") }}
            </router-link>
          </li>
        </ul>
      </li>
      <li class="c-sidebar-nav-dropdown" @click="dropdown($event)">
        <a class="c-sidebar-nav-dropdown-toggle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-alarm" />
          </svg>
          {{ $t("sidebar.overtime.title") }}
          <span
            class="badge badge-warning badge-pill"
            v-show="requestApproves.requestOverTime != 0"
            ><CIcon name="cil-warning"
          /></span>
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/overtime-requests` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("sidebar.overtime.list") }}
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/overtime-requests/approval` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("sidebar.overtime.approval") }}
              <span class="badge badge-info badge-pill">{{
                requestApproves.requestOverTime
              }}</span>
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/overtime-requests/create` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("sidebar.overtime.create") }}
            </router-link>
          </li>
        </ul>
      </li>
      <li class="c-sidebar-nav-dropdown" @click="dropdown($event)">
        <a class="c-sidebar-nav-dropdown-toggle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-note-add" />
          </svg>
          {{ $t("sidebar.additional_timeSheet.title") }}
          <span
            class="badge badge-warning badge-pill"
            v-show="requestApproves.requestTimeSheet != 0"
            ><CIcon name="cil-warning"
          /></span>
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/additional-timesheet` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("sidebar.additional_timeSheet.list") }}
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/additional-timesheet/approval` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("sidebar.additional_timeSheet.approval") }}
              <span class="badge badge-info badge-pill">{{
                requestApproves.requestTimeSheet
              }}</span>
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/additional-timesheet/create` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("sidebar.additional_timeSheet.create") }}
            </router-link>
          </li>
        </ul>
      </li>
      <li class="c-sidebar-nav-dropdown" @click="dropdown($event)">
        <a class="c-sidebar-nav-dropdown-toggle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-description" />
          </svg>
          {{ $t("sidebar.sabbatical.title") }}
          <span
            class="badge badge-warning badge-pill"
            v-show="requestApproves.requestSabbaticalLeave != 0"
            ><CIcon name="cil-warning"
          /></span>
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/sabbatical-leave-request` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("sidebar.sabbatical.list") }}
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/sabbatical-leave-request/approval` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("sidebar.sabbatical.approval") }}
              <span class="badge badge-info badge-pill">{{
                requestApproves.requestSabbaticalLeave
              }}</span>
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/sabbatical-leave-request/create` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("sidebar.sabbatical.create") }}
            </router-link>
          </li>
        </ul>
      </li>
      <li class="c-sidebar-nav-dropdown" @click="dropdown($event)">
        <a class="c-sidebar-nav-dropdown-toggle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-layers" />
          </svg>
          {{ $t("sidebar.skill.title") }}
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/skill-sheet` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("sidebar.skill.create") }}
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <router-link
          :to="{ path: `/note/overtime` }"
          class="c-sidebar-nav-link"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-notes" />
          </svg>
          <!-- {{ $t("note.tutorial") }} -->
          OT
        </router-link>
        <ul class="">
          <li>
            <a @click="scrollTo('create_ot_project')" style="color:white">{{
              $t("note.title.create_ot_project")
            }}</a>
          </li>
          <li>
            <a @click="scrollTo('create_ot_not_project')" style="color:white">{{
              $t("note.title.create_ot_not_project")
            }}</a>
          </li>
          <li>
            <a @click="scrollTo('update_ot')" style="color:white">{{
              $t("note.title.update_ot")
            }}</a>
          </li>
          <li>
            <a @click="scrollTo('list_ot_wait_approval')">{{
              $t("note.title.list_ot_wait_approval")
            }}</a>
          </li>
          <li>
            <a @click="scrollTo('approval_ot')">{{
              $t("note.title.approval_ot")
            }}</a>
          </li>
        </ul>
      </li>
      <li class="c-sidebar-nav-item">
        <router-link
          :to="{ path: `/note/timesheet` }"
          class="c-sidebar-nav-link"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-notes" />
          </svg>
          {{ $t("note.timesheet_request") }}
        </router-link>
      </li>
      <li class="c-sidebar-nav-item">
        <router-link
          :to="{ path: `/note/sabbatical` }"
          class="c-sidebar-nav-link"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-notes" />
          </svg>
          {{ $t("note.sabbatical_request") }}
        </router-link>
      </li>
      <!-- <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/note/overtime` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("note.over_time_request") }}
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/note/timesheet` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("note.timesheet_request") }}
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/note/sabbatical` }"
              class="c-sidebar-nav-link"
            >
              {{ $t("note.sabbatical_request") }}
            </router-link>
          </li>
        </ul> -->
      <div class="ps__rail-x">
        <div class="ps__thumb-x" tabindex="0"></div>
      </div>
      <div class="ps__rail-y">
        <div class="ps__thumb-y" tabindex="0"></div>
      </div>
    </ul>

    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="
        $store.dispatch('layout/setSidebar', ['sidebarMinimize', !minimize])
      "
    />
  </CSidebar>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "Sidebar",
  computed: {
    ...mapState("layout", {
      show: state => state.sidebarShow,
      minimize: state => state.sidebarMinimize
    }),
    ...mapGetters({
      requestApproves: "commons/requestApproves"
    })
  },
  methods: {
    dropdown(event) {
      if (event.target.className.includes("c-sidebar-nav-dropdown-toggle")) {
        let navItem = document.querySelectorAll("li.c-show");
        event.currentTarget.classList.toggle("c-show");

        if (navItem.length > 0) {
          for (var i = 0; i < navItem.length; i++) {
            navItem[i].classList.remove("c-show");
          }
        }
      }
    },
    scrollTo(id) {
      let elmnt = document.getElementById(id);
      const yOffset = -120;
      const y =
        elmnt.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }
};
</script>
<style scoped lang="scss">
.img-logo {
  img {
    max-height: 50px;
    width: auto;
  }
}

.c-sidebar-minimized {
  .img-logo {
    display: none;
  }
}

.c-avatar-img {
  width: 100%;
  height: auto;
  border-radius: unset;
}

.ps__rail-x {
  left: 0px;
  bottom: 0px;
}

.ps__rail-y {
  top: 0px;
  right: 0px;
}

.ps__thumb-x {
  left: 0px;
  width: 0px;
}

.ps__thumb-y {
  top: 0px;
  height: 0px;
}
</style>
